import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';
import {
  ChildrenDefaultProps,
  ChildrenPropTypes,
} from '@/common/proptypes/Base/Children.proptypes';

export const TooltipDefaultProps = {
  ...BaseDefaultProps,
  ...ChildrenDefaultProps,
  context: null,
  message: null,
  position: 'top',
};

export const TooltipPropTypes = {
  ...BasePropTypes,
  ...ChildrenPropTypes,
  context: PropTypes.string,
  message: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  position: PropTypes.oneOf([
    'bottom',
    'bottom-left',
    'bottom-right',
    'left',
    'right',
    'top',
    'top-left',
    'top-right',
  ]),
};
